import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ hasFilters, onClearFilters }) => {
  if (hasFilters) {
    return (
      <div className="text-center py-16">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-6">
          <Icon name="Search" size={24} color="var(--color-text-secondary)" />
        </div>
        <h3 className="text-xl font-semibold text-text-primary mb-2">
          No prompts found
        </h3>
        <p className="text-text-secondary mb-6 max-w-md mx-auto">
          We couldn't find any prompts matching your current filters. Try adjusting your search criteria or clearing the filters.
        </p>
        <Button
          variant="outline"
          onClick={onClearFilters}
          iconName="X"
          iconSize={16}
        >
          Clear Filters
        </Button>
      </div>
    );
  }

  return (
    <div className="text-center py-16">
      <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
        <Icon name="BookOpen" size={32} color="var(--color-primary)" />
      </div>
      <h3 className="text-2xl font-semibold text-text-primary mb-4">
        Your prompt library is empty
      </h3>
      <p className="text-text-secondary mb-8 max-w-lg mx-auto leading-relaxed">
        Start building your collection of AI-generated prompts. Save prompts from the generator to access them anytime and organize your workflow efficiently.
      </p>
      
      <div className="space-y-4">
        <Link to="/prompt-generator">
          <Button variant="default" size="lg" iconName="Plus" iconSize={20}>
            Generate Your First Prompt
          </Button>
        </Link>
        
        <div className="text-sm text-text-secondary">
          <p>💡 Pro tip: Use categories and tags to organize your prompts</p>
        </div>
      </div>

      {/* Feature Highlights */}
      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
        <div className="text-center p-6">
          <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-4">
            <Icon name="Save" size={20} color="#2563EB" />
          </div>
          <h4 className="font-medium text-text-primary mb-2">Save & Organize</h4>
          <p className="text-sm text-text-secondary">
            Keep your best prompts organized with categories and custom tags
          </p>
        </div>
        
        <div className="text-center p-6">
          <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mx-auto mb-4">
            <Icon name="Search" size={20} color="#059669" />
          </div>
          <h4 className="font-medium text-text-primary mb-2">Quick Search</h4>
          <p className="text-sm text-text-secondary">
            Find any prompt instantly with powerful search and filtering
          </p>
        </div>
        
        <div className="text-center p-6">
          <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-4">
            <Icon name="Copy" size={20} color="#7C3AED" />
          </div>
          <h4 className="font-medium text-text-primary mb-2">One-Click Copy</h4>
          <p className="text-sm text-text-secondary">
            Copy any saved prompt to your clipboard with a single click
          </p>
        </div>
      </div>
    </div>
  );
};

export default EmptyState;